import styled from '@emotion/styled';

const IconWrapper = styled.span({
  fontSize: 28
});

export default IconWrapper;
